'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import Link from 'next/link';
import { AchraTabIsotype } from '@/modules/home/components/build-network-section/achra-tab-isotype';
import { BUILD_NETWORK_V2_BLUE_CTA_CLASS, BUILD_NETWORK_V2_PINK_CTA_CLASS, BUILD_NETWORK_V2_VIOLET_CTA_CLASS } from '@/modules/home/lib/constants';
import type { BuildNetworkFeatureColumn } from '@/modules/home/types';
interface FeatureBlockProps {
  feature: BuildNetworkFeatureColumn;
}
function FeatureBlock(t0) {
  const $ = _c(14);
  const {
    feature
  } = t0;
  const showCta = feature.enabled ?? true;
  let t1;
  if ($[0] !== feature.variant) {
    t1 = <span className="col-start-1 row-start-1 shrink-0"><AchraTabIsotype variant={feature.variant} /></span>;
    $[0] = feature.variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== feature.title) {
    t2 = <h3 className="text-foreground col-start-2 row-start-1 min-w-0 pt-0.5 text-lg font-semibold">{feature.title}</h3>;
    $[2] = feature.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== feature.description) {
    t3 = <p className="text-muted-foreground col-start-2 col-end-3 row-start-2 min-w-0 text-sm leading-relaxed lg:col-start-1 xl:col-start-2">{feature.description}</p>;
    $[4] = feature.description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== feature.cta || $[7] !== showCta) {
    t4 = showCta && <div className="col-start-2 col-end-3 row-start-4 min-w-0 pt-1 lg:col-start-1 xl:col-start-2"><Button asChild={true} size="lg" className={cn("w-44 md:w-full", feature.cta.tone === "blue" ? BUILD_NETWORK_V2_BLUE_CTA_CLASS : feature.cta.tone === "violet" ? BUILD_NETWORK_V2_VIOLET_CTA_CLASS : BUILD_NETWORK_V2_PINK_CTA_CLASS)}><Link href={feature.cta.href}>{feature.cta.label}</Link></Button></div>;
    $[6] = feature.cta;
    $[7] = showCta;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="grid h-full grid-cols-[auto_1fr] grid-rows-[auto_auto_1fr_auto] gap-x-2.5 gap-y-2.5 p-4 lg:p-5">{t1}{t2}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export { FeatureBlock };